import PropTypes from 'prop-types';

const CruiseLine = ({ cruiseLine }) => (
  <div className="p-10">
    <img
      src={cruiseLine.cruiseLineLogo}
      alt={cruiseLine.cruiseLineName}
      title={cruiseLine.cruiseLineName}
    />
    <h1 className="text-lg font-bold">
      {cruiseLine.cruiseLineName}
    </h1>
    <p dangerouslySetInnerHTML={{ __html: cruiseLine.cruiseLineDescription }} />
  </div>
);

CruiseLine.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  cruiseLine: PropTypes.object,
};

CruiseLine.defaultProps = {
  cruiseLine: undefined,
};
export default CruiseLine;
